import { type ProgramType } from 'Program';
import { type ExecEdCertCategory } from 'ExecEdEligibility/ExecEdEligibility.types';
import { ExecEdCertCategoryConfigs } from './ExecEdCategories';

export function programCategoryForProgramType(programType: ProgramType) {
    return Object.keys(ExecEdCertCategoryConfigs).find(category =>
        ExecEdCertCategoryConfigs[category as ExecEdCertCategory].programTypes.includes(programType),
    );
}
